import { connect } from 'react-redux';
import { allowEditSelector, phoneSelector } from './selectors';
import { changeView as _changeView } from '../../actions/view';
import { PhoneSmsConfirmationInfoContainer as Component } from './PhoneSmsConfirmationInfoContainer';
import { acceptLicence, acceptMarketingSubscription } from '../../actions/agreement';

function mapStateToProps(state) {
  return {
    phone: phoneSelector(state),
    allowEdit: allowEditSelector(state)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    changeView: function changeView(view) {
      dispatch(_changeView(view));
    },
    resetAgreement: function resetAgreement() {
      dispatch(acceptLicence(false));
      dispatch(acceptMarketingSubscription(false));
    }
  };
}

export var PhoneSmsConfirmationInfoContainer = connect(mapStateToProps, mapDispatchToProps)(Component);